import { render, staticRenderFns } from "./AdminMenuComponent.vue?vue&type=template&id=7a83205a&scoped=true&"
import script from "./AdminMenuComponent.vue?vue&type=script&lang=js&"
export * from "./AdminMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuComponent.vue?vue&type=style&index=0&id=7a83205a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83205a",
  null
  
)

export default component.exports